import {
  Bell,
  Briefcase,
  ChartBar as ChartColumn,
  ChatCircle as MessageSquare,
  Compass,
  CurrencyDollar as DollarSign,
  Gear as Settings,
  House,
  Package,
  ShoppingBag,
  SquaresFour as LayoutDashboard,
  Storefront as Store,
  Users,
} from "@phosphor-icons/react";
import type { Icon } from "@phosphor-icons/react";

export interface NavItem {
  label: string;
  to: string;
  icon: Icon;
}

/** Primary sidebar/rail/bottom-bar nav — DESIGN.md §8.1. */
export const PRIMARY_NAV: NavItem[] = [
  { label: "Home", to: "/feed", icon: House },
  { label: "Explore", to: "/explore", icon: Compass },
  { label: "Communities", to: "/communities", icon: Users },
  { label: "Marketplace", to: "/marketplace", icon: Store },
  { label: "Jobs", to: "/jobs", icon: Briefcase },
  { label: "Messages", to: "/messages", icon: MessageSquare },
  { label: "Notifications", to: "/notifications", icon: Bell },
];

/** Bottom tab bar (<768px) — trimmed to 5 per the board's Navigation row. */
export const BOTTOM_TAB_NAV: NavItem[] = [
  { label: "Home", to: "/feed", icon: House },
  { label: "Explore", to: "/explore", icon: Compass },
  { label: "Communities", to: "/communities", icon: Users },
  { label: "Marketplace", to: "/marketplace", icon: ShoppingBag },
];

/** Overflowed into the bottom bar's "More" menu. */
export const BOTTOM_TAB_MORE: NavItem[] = [
  { label: "Jobs", to: "/jobs", icon: Briefcase },
  { label: "Messages", to: "/messages", icon: MessageSquare },
  { label: "Notifications", to: "/notifications", icon: Bell },
];

/**
 * Dashboard destinations shared by the dashboard's sidebar, rail, and mobile tabs. Every dashboard viewer runs a
 * real store, so the mock-data tabs stay out until their data is real (docs/plans/marketplace-commerce.md M3):
 * Products are real since M4; Orders, Analytics and Customers return with M7; Payouts with Stripe.
 */
export const DASHBOARD_NAV: NavItem[] = [
  { label: "Dashboard", to: "/dashboard", icon: LayoutDashboard },
  { label: "Products", to: "/dashboard/products", icon: Package },
  { label: "Settings", to: "/dashboard/settings", icon: Settings },
];

/** The seller navigation still to restore, tab by tab, as each area moves to real data. */
export const DASHBOARD_COMMERCE_NAV: NavItem[] = [
  { label: "Orders", to: "/dashboard/orders", icon: ShoppingBag },
  { label: "Analytics", to: "/dashboard/analytics", icon: ChartColumn },
  { label: "Payouts", to: "/dashboard/settings", icon: DollarSign },
  { label: "Customers", to: "/dashboard/customers", icon: Users },
];

/** Dashboard shell "Store" group — DESIGN.md §8.1 (Payouts points at Settings). */
export const DASHBOARD_STORE_GROUP: NavItem[] = DASHBOARD_NAV;

/** Dashboard shell trailing group, below the Store group. */
export const DASHBOARD_BOTTOM_GROUP: NavItem[] = [
  { label: "Community", to: "/communities", icon: Users },
  { label: "Messages", to: "/messages", icon: MessageSquare },
  { label: "Notifications", to: "/notifications", icon: Bell },
];
